import { DatePicker, DatePickerProps } from "antd";
import { FC, ReactNode } from "react";
import { withFloatingLabel } from "src/HOC/WithFloatingLabel";
import { cellRender } from "../../utils";

const DatePickerWithLabel = withFloatingLabel(DatePicker);

const sharedProps = {
  format: { format: "DD/MM/YYYY", type: "mask" as const },
  suffixIcon: null,
  superNextIcon: null,
  superPrevIcon: null,
  showNow: false,
  allowClear: false,
  cellRender,
};

const TripDateSelectWeb: FC<{ label: ReactNode; icon?: unknown; validationError?: string[] } & Omit<DatePickerProps, "onChange">> = ({
  label,
  classNames,
  icon,
  validationError,
  ...props
}) => {
  return (
    <DatePickerWithLabel
      label={label}
      {...sharedProps}
      classNames={{
        popup: {
          item: "border-none! focus:border-none! focus-within:border-none! w-full!",
        },
        label: "text-font-minimal!",
      }}
      {...(props as any)}
    />
  );
};

export default TripDateSelectWeb;
